import { CookieProConsentGroup } from '../../enums/cookieProConsentGroups';

/**
 * @description Checks if the user has given consent for analytics cookies by inspecting the active consent groups injected by the OneTrust script. If no groups are provided (e.g. OneTrust not initialised in dev/sandbox environments), defaults to `true` to allow analytics capture in non-production environments.
 * @param consentGroups - An array of consent group IDs (e.g. ['C0001', 'C0002']) parsed from `window.OnetrustActiveGroups`. If undefined or empty, consent is assumed given.
 * @returns `true` if analytics consent is given or if OneTrust has not loaded, `false` otherwise.
 */
export const isAnalyticsConsentGiven = (consentGroups: string[] | undefined): boolean => {
  if (!consentGroups || consentGroups.length === 0) {
    return true;
  }

  return consentGroups.some((group) => group === CookieProConsentGroup.ANALYTICS);
};
